import { KeyValueModel } from "@ifaa-components/ui-components";
import { createAction, props } from "@ngrx/store";
import { SuperannuationProviderItemModel } from "src/app/model/superannuation-provider.model";

export const TransferOptionsRequestAction = createAction('[Rollin Form] get transfer options');

export const TransferOptionsResponseAction = createAction('[Rollin Form] set transfer options', props<{ transferOptions: KeyValueModel[] }>());

export const AddSuperFundAction = createAction('[Rollin Form] add super fund');

export const RemoveSuperFundAction = createAction('[Rollin Form] remove super fund', props<{ index: number }>());

export const ProviderSearchRequestAction = createAction('[Superannuation provider search] request data', props<{ q: string }>());

export const ProviderSearchResponseAction = createAction('[Superannuation provider search] response data ',
    props<{ payload: SuperannuationProviderItemModel[] }>());

export const SelectedProviderAction = createAction('[Superannuation provider search] selected provider',
    props<{ id: number, usi: string, product:string, abn:string, name: string }>());

export const ResetFormStateAction = createAction('[Rollin Form] reset form state');